import IApplicationForTaxBasedOnExternalVm from "../models/shared/IApplicationForTaxBasedOnExternalVm"
import * as IApplicationForTaxBasedOnExternalVmInstance from "../models/shared/IApplicationForTaxBasedOnExternalVm"
import IAction from "../store/IAction"
import { ApplicationCardStatusType } from "../models/enums/ApplicationCardStatusType"
import { FormerLicenseType } from "../models/enums/FormerLicenseType"
import IMunicipalityVm from "../models/shared/IMunicipalityVm"

const UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK"
const UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK_FOR_RESUBMIT = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK_FOR_RESUBMIT"
const UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT"
const UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT_FOR_RESUBMIT = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT_FOR_RESUBMIT"
const UPDATE_FORMER_TAX_LICENSE_MUNICIPALITY = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_MUNICIPALITY"
const UPDATE_FORMER_TAX_LICENSE_NUMBER = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_TAX_LICENSE_NUMBER"
const UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE"
const UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE_FOR_RESUBMIT = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE_FOR_RESUBMIT"
const UPDATE_FORMER_EXPIREDATE = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_EXPIREDATE"
const UPDATE_FORMER_LICENSE_CARD_STATUS = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_LICENSE_CARD_STATUS"
const UPDATE_FORMER_LICENSE_TYPE = "BAT2/applicationsForTaxBasedOnExternalReducer/UPDATE_FORMER_LICENSE_TYPE"

export default function applicationsForTaxBasedOnExternalReducer(state: IApplicationForTaxBasedOnExternalVm = IApplicationForTaxBasedOnExternalVmInstance.empty(), action: IAction): IApplicationForTaxBasedOnExternalVm {
    if (state === null || state === undefined) {
        return state
    }
    switch (action.type) {
        case UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT:
            return { ...state, base64TaxLicenseFrontImage: action.payload, isTaxLicenseFrontImageModified: true }
        case UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT_FOR_RESUBMIT:
            return { ...state, base64TaxLicenseFrontImage: action.payload.value, formerLicenseCardStatus: action.payload.cardStatusType, isTaxLicenseFrontImageModified: true }
        case UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK:
            return { ...state, base64TaxLicenseBackImage: action.payload, isTaxLicenseBackImageModified: true }
        case UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK_FOR_RESUBMIT:
            return { ...state, base64TaxLicenseBackImage: action.payload.value, formerLicenseCardStatus: action.payload.cardStatusType, isTaxLicenseBackImageModified: true }
        case UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE:
            return { ...state, base64EducationalLicenseImage: action.payload, isEducationalLicenseImageModified: true }
        case UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE_FOR_RESUBMIT:
            return { ...state, base64EducationalLicenseImage: action.payload.value, formerLicenseCardStatus: action.payload.cardStatusType, isEducationalLicenseImageModified: true }
        case UPDATE_FORMER_LICENSE_TYPE:
            return { ...state, licenseType: action.payload }
        case UPDATE_FORMER_TAX_LICENSE_NUMBER:
            return { ...state, taxLicenseNumber: action.payload }
        case UPDATE_FORMER_TAX_LICENSE_MUNICIPALITY:
            return { ...state, issuingMunicipality: action.payload }
        case UPDATE_FORMER_EXPIREDATE:
            return { ...state, expireDate: action.payload }
        case UPDATE_FORMER_LICENSE_CARD_STATUS:
            return { ...state, formerLicenseCardStatus: action.payload }
        default:
            return state
    }
}

export function updateFormerTaxLicenseImageFront(value: string, applicationId: string, ) {
    return { type: UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT, payload: value, id: applicationId }
}
export function updateFormerTaxLicenseImageFrontForResubmit(value: string, cardStatusType: ApplicationCardStatusType, applicationId: string) {
    return { type: UPDATE_FORMER_TAX_LICENSE_IMAGE_FRONT_FOR_RESUBMIT, payload: { value, cardStatusType }, id: applicationId }
}
export function updateFormerTaxLicenseImageBack(value: string, applicationId: string) {
    return { type: UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK, payload: value, id: applicationId }
}
export function updateFormerTaxLicenseImageBackForResubmit(value: string, cardStatusType: ApplicationCardStatusType, applicationId: string, ) {
    return { type: UPDATE_FORMER_TAX_LICENSE_IMAGE_BACK_FOR_RESUBMIT, payload: { value, cardStatusType }, id: applicationId }
}
export function updateFormerEducationalicenseImage(value: string, applicationId: string) {
    return { type: UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE, payload: value, id: applicationId }
}
export function updateFormerEducationalicenseImageForResubmit(value: string, cardStatusType: ApplicationCardStatusType, applicationId: string) {
    return { type: UPDATE_FORMER_EDUCATIONAL_LICENSE_IMAGE_FOR_RESUBMIT, payload: { value, cardStatusType }, id: applicationId }
}
export function updateFormerLicenseType(value: FormerLicenseType, applicationId: string) {
    return { type: UPDATE_FORMER_LICENSE_TYPE, payload: value, id: applicationId }
}
export function updateFormerTaxLicenseNumber(value: string, applicationId: string) {
    return { type: UPDATE_FORMER_TAX_LICENSE_NUMBER, payload: value, id: applicationId }
}
export function updateFormerTaxLicenseMunicipality(value: IMunicipalityVm, applicationId: string) {
    return { type: UPDATE_FORMER_TAX_LICENSE_MUNICIPALITY, payload: value, id: applicationId }
}
export function updateFormerExpireDate(value: string, applicationId: string) {
    return { type: UPDATE_FORMER_EXPIREDATE, payload: value, id: applicationId }
}
export function updateFormerLicenseCardStatus(value: ApplicationCardStatusType, applicationId: string) {
    return { type: UPDATE_FORMER_LICENSE_CARD_STATUS, payload: value, id: applicationId }
}